// Definición de defaults

export const defaultSentidoFallo: SentidoFalloProps = {
    idSentidoFallo:    0,
    descripcion:       '',
    activo:            false,
}

// Creación de interfaces

export interface SentidoFalloProps {
    idSentidoFallo:        number;
    descripcion:             string;
    activo:                  boolean;
}